import { CheckCircle } from '@mui/icons-material'
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'

import logoWhite from '~/assets/images/corp/logo-white.webp'
import PartnerThemeWrapper from '~/features/partners/components/partnerThemeWrapper'
import { isLibbyDomain } from '~/features/partners/utils'
import Logo from '~/layouts/auth/header/logo'
import heyLibbyCapabilities from '~/layouts/auth/utils'
import { TNavigateState } from '~/models/auth'
import rem from '~/utils/ui'

function AuthLayout() {
  const theme = useTheme()
  const { state } = useLocation() as { state: TNavigateState | null }
  const isPartner = !isLibbyDomain()

  // Need to decide what to wrap if partner themed
  const renderWrapper = () => {
    if (state?.isPartnerThemed || isPartner) {
      return (
        <PartnerThemeWrapper>
          <Outlet />
        </PartnerThemeWrapper>
      )
    }

    return <Outlet />
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xxxs: 'column', md: 'row' },
        justifyContent: 'space-between',
        height: '100vh',
      }}
    >
      <Stack sx={{ width: '100%' }}>
        <Box sx={{ ml: 2, mt: 1 }}>
          <Logo />
        </Box>
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingBlock: rem(100),
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              alignSelf: 'center',
            }}
          >
            {renderWrapper()}
          </Box>
        </Box>
      </Stack>
      {!(isPartner || state?.isPartnerThemed) && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: theme.palette.menuBackground,
            width: '100%',
            color: theme.palette.common.white,
          }}
        >
          <Stack
            sx={{
              width: { xxxs: '100%', md: '80%', lg: '60%', xl: '50%' },
              maxWidth: rem(600),
              p: { xxxs: 4, md: 0 },
              gap: { xxxs: 4, md: 3 },
            }}
          >
            <Box sx={{ textAlign: 'center', minWidth: rem(200) }}>
              <Typography
                component="span"
                sx={{
                  fontWeight: theme.typography.fontWeightBold,
                  fontSize: { xxxs: rem(30), md: rem(50) },
                  lineHeight: 1.2,
                  letterSpacing: rem(3),
                }}
              >
                Get your money&apos;s worth with
              </Typography>
              <Box
                sx={{
                  display: 'inline-flex',
                  flexWrap: 'nowrap',
                }}
              >
                <Box
                  component="img"
                  src={logoWhite}
                  sx={{
                    width: { xxxs: rem(120), md: rem(180) },
                    height: { xxxs: rem(40), md: rem(60) },
                    marginInline: rem(5),
                    position: 'relative',
                    top: { xxxs: rem(12), md: rem(17) },
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    fontWeight: theme.typography.fontWeightBold,
                    fontSize: { xxxs: rem(30), md: rem(50) },
                    lineHeight: 1.2,
                    letterSpacing: rem(3),
                    position: 'relative',
                    top: { xxxs: rem(10), md: rem(12) },
                  }}
                >
                  !
                </Typography>
              </Box>
            </Box>
            <Box sx={{ minWidth: rem(200) }}>
              <List>
                {heyLibbyCapabilities.map((capability) => (
                  <ListItem
                    disablePadding
                    key={capability}
                    sx={{
                      my: 2,
                      '& .MuiListItemIcon-root': {
                        minWidth: rem(32),
                      },
                    }}
                  >
                    <ListItemIcon sx={{ color: theme.palette.primary1 }}>
                      <CheckCircle />
                    </ListItemIcon>
                    <ListItemText primary={capability} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Stack>
        </Box>
      )}
    </Box>
  )
}

export default AuthLayout
